import moment from 'moment';
import { useEffect, useState } from 'react';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import type { SemanticDatepickerProps } from 'react-semantic-ui-datepickers/dist/types';

import type { QuestionnaireDateProps } from './item-props';

/** LinkIds for date questions that should default to today's date when unanswered. */
export const DEFAULT_TODAY_LINK_IDS = ['PW-RD-CONSULT-13', 'PW-HEALTH-GEN-44a'];

export default function DateItem(props: QuestionnaireDateProps) {
  const [dateState, setDateState] = useState<SemanticDatepickerProps['value']>(null);

  useEffect(() => {
    if (
      props?.question?.linkId &&
      DEFAULT_TODAY_LINK_IDS.includes(props.question.linkId) &&
      !props.currentAnswer?.[0]?.valueDate &&
      props.enable &&
      props.addAnswer
    ) {
      const today = moment().format('YYYY-MM-DD');
      props.addAnswer([{ valueDate: today }], props.i, props.j);
    }
     
  }, [props?.question?.linkId, props.currentAnswer, props.i, props.j, props.answersStateReady, props.enable]);

  // The picker's `value` is `Date | Date[] | null` because one props type serves
  // both the basic and range pickers; `moment` has no `Date[]` overload. Passing
  // the union through preserves the existing Invalid Date for the range arm,
  // which a basic picker never reaches.
  const handleInput: SemanticDatepickerProps['onChange'] = (_event, { name: _name, value }) => {
    if (value) {
      const formatedDate = moment(value as moment.MomentInput).format('YYYY-MM-DD');
      setDateState(value);
      props.addAnswer([{ valueDate: formatedDate }], props.i, props.j);
    } else {
      props.addAnswer(null, props.i, props.j);
    }
  };

  return !props.enable ? (
    <SemanticDatepicker
      disabled
      required
      autoComplete="false"
      datePickerOnly
      name="date"
      value={null}
      clearable={true}
      format="YYYY-MM-DD"
      placeholder="Enter Answer Here"
      onChange={handleInput}
    />
  ) : props.currentAnswer ? (
    <SemanticDatepicker
      required
      autoComplete="false"
      datePickerOnly
      name="date"
      value={
        props.currentAnswer
          ? moment(props.currentAnswer?.[0]?.valueDate)?.toDate()
          : dateState
            ? moment(dateState as moment.MomentInput).toDate()
            : null
      }
      clearable={true}
      format="YYYY-MM-DD"
      placeholder="Enter Answer Here"
      onChange={handleInput}
    />
  ) : (
    <SemanticDatepicker
      required
      autoComplete="false"
      datePickerOnly
      name="date"
      value={null}
      clearable={true}
      format="YYYY-MM-DD"
      placeholder="Enter Answer Here"
      onChange={handleInput}
    />
  );
}
